<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/')" class="breadcrumbs-txt pointer">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div class="breadcrumbs-txt1">{{ productDetailsList[productIndex].fullName }}</div>
    </div>
    <div class="main-content flex column jcs">
      <div>
        <div class="product-detailsBox flex jcs">
          <div class="product-detailsImgBox flex column ai">
            <img @click="btnPictureView" class="iconMagnifyingGlass pointer" src="@/assets/productDetails/iconMagnifyingGlass.png" alt="" />
            <img class="productImg" :src="require(`@/assets/productDetails/${productIndex + 1}_${productImgIdx}.png`)" alt="" />
            <div class="product-operationImgBox flex ai jcs">
              <img @click="changeProductImg('left')" class="iconLeftArrow pointer" src="@/assets/productDetails/iconLeftArrow.png" alt="" />
              <div class="product-imgListBox flex">
                <div @click="productImgIdx = index + 1" :style="productImgIdx == index + 1 ? { border: '0.01rem solid #DCDCDC' } : { border: '0.01rem solid #FFFFFF' }" v-for="(item, index) in productDetailsList[productIndex].productImgList.length" key="index" class="product-imgBox flex ai jcc pointer">
                  <img class="imgBox-img" :src="require(`@/assets/productDetails/${productIndex + 1}_${index + 1}.png`)" alt="" />
                </div>
              </div>
              <img @click="changeProductImg('right')" class="iconLeftArrow pointer" src="@/assets/productDetails/iconRightArrow.png" alt="" />
            </div>
          </div>
          <div class="product-detailsTxtBox">
            <div class="flex" style="align-items: flex-end">
              <p class="product-detailsName">{{ productDetailsList[productIndex].name }}</p>
              <p class="product-deputyName" v-if="productDetailsList[productIndex].deputyName">{{ productDetailsList[productIndex].deputyName }}</p>
            </div>
            <div class="product-englishName flex" style="align-items: flex-end">
              <p class="product-detailsEnglishName">{{ productDetailsList[productIndex].englishName }}</p>
              <p class="product-deputyEnglishName" v-if="productDetailsList[productIndex].englishDeputyName">{{ productDetailsList[productIndex].englishDeputyName }}</p>
            </div>
            <div class="product-usageBox">
              <div class="product-key">用法用量</div>
              <div class="product-value">{{ productDetailsList[productIndex].usage }}</div>
            </div>
            <div class="product-usageBox">
              <div class="product-key">配料明细</div>
              <div class="product-value">{{ productDetailsList[productIndex].ingredients }}</div>
            </div>
            <div v-if="productDetailsList[productIndex].notIncluded" class="product-usageBox">
              <div class="product-key">不含</div>
              <div class="product-value">{{ productDetailsList[productIndex].notIncluded }}</div>
            </div>
            <div class="dividing-line"></div>
            <div class="flex">
              <img class="iconTianmao" src="@/assets/productDetails/iconTianmao.png" alt="" />
              <img class="iconJingdong" src="@/assets/productDetails/iconJingdong.png" alt="" />
            </div>
          </div>
        </div>
        <img v-if="productDetailsList[productIndex].banner" class="product-bannerImg" :src="require(`@/assets/productDetails/banner${productIndex + 1}.png`)" alt="" />
      </div>
      <Footer />
    </div>
    <el-image-viewer v-if="showImageViewer" :url-list="srcList" @close="showImageViewer = false" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import Footer from "../../components/Footer.vue";
import { useRoute } from "vue-router";
import productDetailsList from "@/utils/productDetails.json";
import { ElImageViewer } from "element-plus";
import router from "@/router";
const route = useRoute();
// 产品名称
var productName = ref("");
var productIndex = ref(null);
// 获取数据的函数
async function fetchData(params) {
  // 根据参数获取数据
  productName.value = params.name;
  productIndex.value = productDetailsList.findIndex((item) => item.fullName === productName.value);
}
// 初始化加载
fetchData(route.query);
// 监听路由变化
watch(
  () => route.query,
  (newQuery) => {
    fetchData(newQuery);
  },
  { deep: true }
);
// 产品图片索引
const productImgIdx = ref(1);
// 左右箭头更改图片
const changeProductImg = (direction) => {
  if (direction === "left") {
    if (productImgIdx.value > 1) {
      productImgIdx.value--;
    }
  } else if (direction === "right") {
    if (productImgIdx.value < productDetailsList[productIndex.value].productImgList.length) {
      productImgIdx.value++;
    }
  }
};
// 是否展示图片查看器
const showImageViewer = ref(false);
// 图片查看器列表
const srcList = ref([]);
// 图片查看
const btnPictureView = () => {
  srcList.value = [require(`@/assets/productDetails/${productIndex.value + 1}_${productImgIdx.value}.png`)];
  showImageViewer.value = true;
};
</script>

<style src="./productDetails.css" scoped></style>
